import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGraduationCap = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M21.42 10.922C21.599 10.843 21.7509 10.7133 21.8569 10.5488C21.9629 10.3843 22.0183 10.1924 22.0163 9.99673C22.0143 9.80108 21.9549 9.61031 21.8456 9.44807C21.7362 9.28584 21.5816 9.15925 21.401 9.08399L12.83 5.17999C12.5694 5.06114 12.2864 4.99963 12 4.99963C11.7136 4.99963 11.4306 5.06114 11.17 5.17999L2.6 9.07999C2.42197 9.15796 2.27052 9.28613 2.16417 9.44881C2.05782 9.61149 2.00118 9.80163 2.00118 9.99599C2.00118 10.1903 2.05782 10.3805 2.16417 10.5432C2.27052 10.7059 2.42197 10.834 2.6 10.912L11.17 14.82C11.4306 14.9388 11.7136 15.0003 12 15.0003C12.2864 15.0003 12.5694 14.9388 12.83 14.82L21.42 10.922Z",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22 10V16",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6 12.5V16C6 16.7956 6.63214 17.5587 7.75736 18.1213C8.88258 18.6839 10.4087 19 12 19C13.5913 19 15.1174 18.6839 16.2426 18.1213C17.3679 17.5587 18 16.7956 18 16V12.5",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgGraduationCap;
